import { knownColsCamel } from "@/components/grid-wrapper/dynamic-columns-generator";
import UIAutoCompelete from "@/components/ui-controls/auto-complete";
import UIComboBox from "@/components/ui-controls/combo-box";
import UIDatePicker from "@/components/ui-controls/date-field";
import UIRadioButton from "@/components/ui-controls/radio-button";
import UISelect from "@/components/ui-controls/select";
import TagsInput from "@/components/ui-controls/tags-input";
import UITextField from "@/components/ui-controls/textfield";
import { Box, Typography } from "@mui/material";

export const getOptions = (options, filterBy, numericId = false) => {
  if (typeof options === "string") {
    if (knownColsCamel[options]) {
      if (filterBy) {
        return filterBy(knownColsCamel[options](numericId));
      }
      return knownColsCamel[options](numericId);
    }
    return [];
  } else {
    return options || [];
  }
};

export const getType = (field = {}) => {
  const { uiHint = "", type = "" } = field;
  switch (type.toLowerCase()) {
    case "text":
    case "number":
      return type.toLowerCase();

    case "key":
    case "boolean":
      return "select";

    case "datetime":
      return "date";
    case "multikey":
      return "combo-box";
    // return "auto-complete";
    default:
      return "";
  }
};

export const getCompByType = (type = "", fieldProps = {}, parentSx = {}) => {
  const {
    name = "",
    value = "",
    title = "",
    handleChange,
    disabled = false,
    options = [],
    size = "medium",
    noneSelectable = false,
    isMultiSelectEnable = false,
    postfix = null,
    error,
  } = fieldProps;

  switch (type) {
    case "text":
    case "inputSelectCombo": // for firstName only
    case "number":
      return (
        <Box key={name} sx={{ mt: 1.5, mb: 1, mx: 0.5, ...parentSx }}>
          <UITextField
            size={size}
            name={name}
            title={title}
            value={value}
            onChange={handleChange}
            type={type == "phone" ? "text" : type}
            disabled={disabled}
            sx={{ background: "transparent" }}
            postfix={postfix}
          />
        </Box>
      );

    // case "boolean":
    case "select":
      // case "multivalue":
      let optionsToCheck = options || [];
      if (
        value &&
        optionsToCheck.length &&
        !optionsToCheck.find((op) => op.value == value)
      ) {
        optionsToCheck = [
          ...optionsToCheck,
          { label: "Deleted", value: value, disabled: true },
        ];
      }
      return (
        <Box key={name} sx={{ mt: 1.5, mb: 1, mx: 0.5 }}>
          <UISelect
            size={size}
            name={name}
            // value={value}
            value={noneSelectable ? value : value || ""}
            title={title}
            onChange={handleChange}
            options={optionsToCheck}
            disabled={disabled}
            helperTextStyles={{ mx: 0.5, mt: 1 }}
            clearable={false}
            // onBlur={handleOnBlur}
            // error={error}
          />
        </Box>
      );
    case "auto-complete":
      return (
        <Box key={name} sx={{ mt: 1.5, mb: 1, mx: 0.5, ...parentSx }}>
          <UIAutoCompelete
            title={title}
            name={name}
            selected={value}
            size={size}
            options={options}
            handleChange={handleChange}
            loading={false}
            variant="outlined"
            isFilterWrapper={false}
            isMultiSelectEnable={isMultiSelectEnable}
            error={error}
          />
        </Box>
      );

    case "tag":
      return (
        <Box key={name} sx={{ mt: 1.5, mb: 1, mx: 0.5 }}>
          <TagsInput
            title={"Set tags"}
            name={"tags"}
            allowAdd={false}
            allowDelete={false}
            // value={value || null}
            handleChange={(tag) =>
              handleChange(tag.map((t) => ({ ...t, tagId: t.id })))
            }
            tagOptions={options}
            size={size}
            // disabled={disableFields}
            // colorOptions={getOptions(props.colorSource)}
            savedTags={value}
            showChipOnFieldOnly={true}
          />
        </Box>
      );

    case "date":
      return (
        <Box key={name} sx={{ mt: 1, mb: 1, mx: 0.5, ...parentSx }}>
          <UIDatePicker
            {...fieldProps}
            title={title}
            name={name}
            value={value}
            size={size}
            onChange={handleChange}
            format="DD-MMM-YYYY"
            sx={{ width: "100%" }}
          />
        </Box>
      );
    case "radio":
      return (
        <Box key={name} sx={{ my: 1.5, mx: 0.5 }}>
          <UIRadioButton
            checked={value}
            name={name}
            label={
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 400 }}
                color={"custom.text"}
              >
                {title}
              </Typography>
            }
            handleChange={handleChange}
          />
        </Box>
      );

    case "combo-box":
      return (
        <Box key={name} sx={{ mt: 1.5, mb: 1, mx: 0.5, ...parentSx }}>
          <UIComboBox
            name={name}
            value={value || []}
            title={title}
            onChange={handleChange}
            options={options}
            multiple={isMultiSelectEnable}
            size={size}
          />
        </Box>
      );

    default:
      return null;
  }
};

export const filterTriggerColsByLocationType = (
  criteriaCols = [],
  locationType
) => {
  const filterCols = (arr, inverse = false) =>
    criteriaCols.filter((col) =>
      inverse ? !arr.includes(col.columnKey) : arr.includes(col.columnKey)
    );

  switch (locationType) {
    case 1: {
      return filterCols(["CountryId"]);
    }
    case 2: {
      return filterCols(["CountryId", "StateProvinceId"]);
    }
    case 3: {
      return filterCols(["ZipCode"], true);
    }
    case 4: {
      return filterCols(["ZipCode"]);
    }
    default: {
      return [];
    }
  }
};
